import { Flex, Image } from "@chakra-ui/react";
import { CustomText } from "@root/components/common/components";
import { ViewableImage } from "@root/components/common/images/viewAbleImage";
import { updateImagePopup } from "@root/store/slices/entities";
import { isConGptChat } from "@root/utils/chatHelper";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { PDFItem } from "../components";
import { useMainChatContext } from "@root/context/kps-chat-context";
import { SearchQuestionIcon } from "@root/assets/icons/SearchQuestionIcon";
import { ChatQuestionIcon } from "@root/assets/icons/ChatQuestionIcon";
import { useLocation } from "react-router-dom";
import { ROUTE_NAMES } from "@root/constants";

function UserChat(props: any) {
  const { chat, editable, mode } = props;
  const { childchats, childChatIndex, files, pid } = chat;
  const question = true;
  const questionType = true;
  const [input, setInput] = useState("");
  const dispatch = useDispatch();
  const { filesPreview } = useMainChatContext();
  const { pathname } = useLocation();
  const isKCSChat = pathname.includes(ROUTE_NAMES.KCS);

  const docName = files?.path;

  const onImageClick = (url: string) => {
    dispatch(
      updateImagePopup({
        url,
      } as any)
    );
  };

  const userInput =
    childChatIndex === -1 || !childChatIndex
      ? chat?.input
      : isConGptChat(pid)
      ? childchats?.[childChatIndex]?.[0]?.input
      : chat?.input;

  return (
    <Flex
      // flexDirection="column"
      justifyContent={"flex-end"}
      alignItems={"flex-start"}
      marginLeft={"50px"}
      mt={"40px"}
    >
      {question && questionType && (
        <Flex
          alignItems={"center"}
          // bgColor={"#40599B0A"}
          px={"20px"}
          borderRadius={"16px"}
        >
          <Flex
            display={"block"}
            border={"1px solid"}
            borderColor={editable ? "theme.button.primary" : "transparent"}
            px={"12px"}
            pt={"12px"}
            borderRadius={editable ? "8px" : "10px"}
            outline={0}
            justifyContent={"center"}
            alignItems={"center"}
            bgColor={"transparent"}
            width={"fit-content"}
          >
            {docName && <PDFItem text={docName} />}
            <Flex
              p={"1px"}
              borderTopRadius={"16px"}
              borderBottomLeftRadius={"16px"}
              sx={{
                background:
                  "linear-gradient(270deg, rgba(177, 89, 6, 0.9) 22.6%, rgba(0, 94, 184, 0.9) 100%)",
              }}
            >
              <CustomText
                borderTopRadius={"16px"}
                borderBottomLeftRadius={"16px"}
                p={"8px"}
                bg={"white"}
                contentEditable={editable}
                outline={0}
                fontSize={"16px"}
                text={userInput || ""}
                wordBreak={"break-all"}
                onInput={(e: any) => setInput(e?.target?.innerText)}
                width={"fit-content"}
                isUserChat={isKCSChat}
              />
            </Flex>
            <Image
              mt={4}
              mr={3}
              src={
                chat?.meta?.c?.signedUrl ||
                (filesPreview?.[0] && URL.createObjectURL(filesPreview?.[0]))
              }
            />

            <Flex gap={"16px"} flexWrap={"wrap"}>
              {chat?.selectedFiles &&
                chat?.selectedFiles?.length > 0 &&
                chat?.selectedFiles?.map((url: string) => (
                  <ViewableImage url={url} onClick={() => onImageClick(url)} />
                ))}
            </Flex>
          </Flex>

          {/* {showEditOptions && (
            <UserEditOptions
              childChats={childchats}
              chatIndex={childChatIndex}
              onBack={onBack}
              childChatsLength={childChatsLength}
              onNext={onNext}
              setEditable={setEditable}
            />
          )} */}
          {/* {editable && (
            <Flex mt={"12px"}>
              <CustonButtom
                onClick={() => {
                  editSubmitHandler(input);
                  setEditable(false);
                }}
                height="37px"
                fontSize="12px"
                text="Save"
              />
              <CustonButtom
                onClick={() => setEditable(false)}
                height="37px"
                variant="light"
                fontSize="12px"
                text="Cancel"
              />
            </Flex>
          )} */}
        </Flex>
      )}
    </Flex>
  );
}

export default UserChat;
